var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex-center search-box padding-x-10",
      attrs: { id: "menuSearch" },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "flex-1 padding-x-10 position-relative padding-y-5 search-wrapper flex-start",
        },
        [
          _c("img", {
            staticClass: "search-icon",
            attrs: { src: require("@/static/icon-search.png") },
          }),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.keyWords,
                expression: "keyWords",
              },
            ],
            staticClass: "search-input margin-left-5 flex-1",
            attrs: { placeholder: "请输入菜单名称" },
            domProps: { value: _vm.keyWords },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.keyWords = $event.target.value
              },
            },
          }),
          _vm.keyWords
            ? _c(
                "div",
                {
                  staticClass: "clear flex-center padding-3",
                  on: { click: _vm.clear },
                },
                [_c("i", { staticClass: "el-icon-close font-14 color-333" })]
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }